import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { VegaService } from '../vega.service';


@Component({
	selector: 'edit-layouts-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
	],
	templateUrl: './edit-layouts.dialog.html',
	styleUrl: './edit-layouts.dialog.scss',
})

export class EditLayoutsDialog {

	public dialogRef = inject(MatDialogRef<EditLayoutsDialog>);
	public dialogContext: DialogContext<{}> = inject(MAT_DIALOG_DATA);
	public vegaService = inject(VegaService);


	public actions: DialogAction[] = [
		{
			id: 'edit',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Edit'),
			linkType: 'no-action',
			willCloseDialog: false,
		},
		{
			id: 'delete',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Delete'),
			linkType: 'no-action',
			willCloseDialog: false,
		},
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: 'no-action',
			willCloseDialog: true,
		},
	];


}